import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editUserInfo } from '../../actions/userActions';
import EditProfileView from '../../containers/Profile/EditProfile/EditProfileView';


const EditUser = ({ history }) => {
    const { userInfo } = useSelector((state) => state.userInfo);
    const dispatch = useDispatch()
 

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {

            username:userInfo?.username?.trim().length>0 ? userInfo?.username : "",
            name: userInfo?.name || "",
            lastname: userInfo?.lastname || "",
            phone: userInfo?.phone || "",
            gender: userInfo?.gender || "",
            birthDate: userInfo?.birthDate || "",
            ubication: {
                currentCountry: userInfo?.ubication?.currentCountry || "Colombia",
                currentDepartment: userInfo?.ubication?.currentDepartment || "",
                currentCity: userInfo?.ubication?.currentCity || "",
                currentAddress: userInfo?.ubication?.currentAddress || "",
                currentLocation: userInfo?.ubication?.currentLocation || "",
            },
            privateData: {
                email: userInfo?.privateData?.email || 0,
                birthDate: userInfo?.privateData?.birthDate || 0,
                phone: userInfo?.privateData?.phone || 0,
                ubication: userInfo?.privateData?.ubication || 0,
                gender: userInfo?.privateData?.gender || 0,
            },
            hobbies: userInfo?.hobbies || "",
            aspiration: userInfo?.aspiration || "",
        },
        //validationSchema: validationSchema,
        onSubmit: (values) => {
            dispatch(editUserInfo(values, history, userInfo))
        }
    })

    return <EditProfileView formik={formik} />;
};

export default EditUser;
